import React, { PropsWithChildren } from 'react';

import classes from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipSection/TooltipSection.module.scss';

interface Props extends PropsWithChildren {
    subTitle: string;
    subTitleInfo?: string;
}

export const TooltipSection = ({ subTitle, subTitleInfo, children }: Props) => {
    return (
        <div className={classes.section}>
            <div className={classes.subHeader}>
                <div className={classes.subTitle}>{subTitle}</div>
                {subTitleInfo && <div>{subTitleInfo}</div>}
            </div>
            <div className={classes.rowItemsSection}>{children}</div>
        </div>
    );
};
